import { format, isToday } from 'date-fns'

export const formatDisruptionDate = (date: string): string => {
    const isTimeSpecified = format(date, 'HH:mm') !== '00:00' && format(date, 'HH:mm') !== '23:59'
    return isToday(date)
        ? `Today,\n${format(date, 'HH:mm')}`
        : isTimeSpecified
          ? format(date, 'dd/MM/yy, HH:mm')
          : format(date, 'dd/MM/yy')
}
